import React from "react";
import { Container } from "react-bootstrap";
import NotFound from "../components/shared/Loader/NotFound";

const NotFoundRoute = () => {
  return (
    <div className="main-container">
      <div className="not-found-container py-4 pb-5">
        <Container
          className=" d-flex align-items-center mobile_height_none"
          style={{ height: "500px" }}
        >
          <NotFound height={250} width={250} />
        </Container>
      </div>
    </div>
  );
};

export default NotFoundRoute;
